import { mixpanelObject } from 'src/utils/analytics';

import {
  MIXPANEL_POP_UP_NAME,
  MIXPANEL_CONSUMPTION_CONTENT_LANGUAGE_UPDATE,
  MIXPANEL_POP_UP_TYPE,
  MIXPANEL_NATIVE,
  MIXPANEL_POP_UP_GROUP,
  MIXPANEL_NOT_AVAILABLE,
  MIXPANEL_ELEMENT,
  MIXPANEL_CROSS,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_CTA
} from '../../utils/analytics/mixpanel/mixpanelConstants';
import {
  popupCTAEvent,
  timeEvent
} from '../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { userOnboarPopupLaunchEvent } from '../userOnboard/MixpanelHelper';

export const triggerClosePopupMixpanelEvents = () => {
  mixpanelObject.setProperty(
    MIXPANEL_POP_UP_NAME,
    MIXPANEL_CONSUMPTION_CONTENT_LANGUAGE_UPDATE
  );
  mixpanelObject.setProperty(MIXPANEL_POP_UP_TYPE, MIXPANEL_NATIVE);
  mixpanelObject.setProperty(MIXPANEL_POP_UP_GROUP, MIXPANEL_NOT_AVAILABLE);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, MIXPANEL_CROSS);
  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_CTA);
  popupCTAEvent();
};

export const triggerClickMoreLanguagesMixpanelEvents = (
  elementName: string
) => {
  mixpanelObject.setProperty(
    MIXPANEL_POP_UP_NAME,
    MIXPANEL_CONSUMPTION_CONTENT_LANGUAGE_UPDATE
  );
  mixpanelObject.setProperty(MIXPANEL_POP_UP_TYPE, MIXPANEL_NATIVE);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, elementName);
  mixpanelObject.setProperty(MIXPANEL_POP_UP_GROUP, MIXPANEL_NOT_AVAILABLE);
  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_CTA);
  popupCTAEvent();
  timeEvent();
};

export const triggerSaveSettingsMixpaneEvents = (elementName: string) => {
  mixpanelObject.setProperty(
    MIXPANEL_POP_UP_NAME,
    MIXPANEL_CONSUMPTION_CONTENT_LANGUAGE_UPDATE
  );
  mixpanelObject.setProperty(MIXPANEL_POP_UP_TYPE, MIXPANEL_NATIVE);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, elementName);
  mixpanelObject.setProperty(MIXPANEL_POP_UP_GROUP, MIXPANEL_NOT_AVAILABLE);
  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_CTA);
  popupCTAEvent();
};

export const triggerPopupLaunchMixpanelEvents = () => {
  mixpanelObject.setProperty(
    MIXPANEL_POP_UP_NAME,
    MIXPANEL_CONSUMPTION_CONTENT_LANGUAGE_UPDATE
  );
  mixpanelObject.setProperty(MIXPANEL_POP_UP_TYPE, MIXPANEL_NATIVE);
  mixpanelObject.setProperty(MIXPANEL_POP_UP_GROUP, MIXPANEL_NOT_AVAILABLE);
  userOnboarPopupLaunchEvent();
};
